<template>
  <div @keyup.enter="checkStakeholder">
    <v-container
      grid-list-md
      text-center
    >
      <v-img
        v-if="showBranding()"
        :src="getBrandingImage()"
        class="banner"
      />
      <h4 v-if="SR20Survey">
        Please provide your contact information
      </h4>
      <h4 v-else>
        {{ $t("message.signin") }}
      </h4>
      <v-spacer />
      <v-form ref="form">
        <v-layout
          row
          wrap
        >
          <v-flex :class="sizing">
            <v-text-field
              v-model.trim="fname"
              :rules="firstrules"
              outlined
              required
              :label="first"
            />
          </v-flex>
          <v-flex :class="sizing">
            <v-text-field
              v-model.trim="lname"
              :rules="lastrules"
              outlined
              required
              :label="last"
            />
          </v-flex>
          <v-flex :class="sizing">
            <v-text-field
              v-model.trim="postalCode"
              :rules="ziprules"
              outlined
              required
              :label="zip"
            />
          </v-flex>
          <v-spacer />
          <v-flex xs12>
            <v-btn
              class="white--text"
              color="#015594"
              :disabled="this.$v.$invalid"
              @click="checkStakeholder"
            >
              {{ $t("message.check") }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import rules from "@/validation.js";
import esrules from "@/esvalidation.js";
import validations from "@/validation.js";

import { createHelpers } from "vuex-map-fields";
import { mapActions, mapState } from "vuex";

const { mapFields } = createHelpers({
  getterType: `stakeholders/getField`,
  mutationType: `stakeholders/updateField`
});

import { showBrandingForComponent, getBrandingImageFilePath } from "@/utils/dynamicBranding.js";

export default {
  name: "StakeholderLookup",
  data: () => ({
    rules: rules.rules,
    esrules: esrules.esrules
  }),
  computed: {
    ...mapFields(["form.fname", "form.lname", "form.postalCode"]),
    ...mapState("programs", ["programs"]),
    ...mapState("projects", ["projects"]),
    ...mapState("survey", ["surveys"]),
    first() {
      return this.$t("message.first");
    },
    last() {
      return this.$t("message.last");
    },
    zip() {
      return this.$t("message.zip");
    },
    firstrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.fnameRules;
      } else {
        return this.esrules.fnameRules;
      }
    },
    lastrules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.lnameRules;
      } else {
        return this.esrules.lnameRules;
      }
    },
    ziprules: function() {
      if (this.$i18n.locale === "en") {
        return this.rules.postalCodeRules;
      } else {
        return this.esrules.postalCodeRules;
      }
    },
    sizing() {
      if (this.$vuetify.breakpoint.xs) {
        return "xs12"
      }
      return "xs4"
    },
    SR20Survey() {
      return this.$router.currentRoute.params.survey_name === "220138-2_220635-2and-4_SR_20" || this.$router.currentRoute.params.survey_name === "441038-1_413062-4and-5_I-10_Santa_Rosa_and_Okaloosa"
    }
  },
  created() {
    this.clearCurrentStakeholder();
    this.fetchSurveys();
  },
  validations: validations.validations,
  methods: {
    ...mapActions("survey", ["fetchSurveys"]),
    ...mapActions("stakeholders", [
      "clearCurrentStakeholder",
      "setCurrentStakeholder",
      "setCurrentStakeholderOriginal",
      "setCurrentStakeholderID",
      "showNetworkAlert",
      "showDuplicateAlert",
      "toggleRegisterModal",
      "toggleUpdateModal",
      "stakeholderLookUp"
    ]),
    checkStakeholder() {
      let fname = this.$store.state.stakeholders.form.fname;
      let lname = this.$store.state.stakeholders.form.lname;
      let postalCode = this.$store.state.stakeholders.form.postalCode;

      if (!fname || !lname || !postalCode || this.$v.$invalid) {
        return;
      }
      return this.stakeholderLookUp({
        first_name: fname,
        last_name: lname,
        postal_code: postalCode
      });
    },
    showBranding() {
      return showBrandingForComponent(this.$router.currentRoute.params, this.programs, this.projects, this.surveys, 'StakeholderLookUpForm')
    },
    getBrandingImage() {
      return getBrandingImageFilePath('StakeholderLookUpForm.')
    }
  }
};
</script>

<style scoped>
.banner {
  width: 45%;
  margin-left: 29%;
  margin-top: 1%;
  margin-bottom: 1%;
}</style>
